export default __webpack_public_path__ + "static/media/imp.59fa539b.png";